module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10188.8112bf30.jpg";